import { getCanonicalStandardCode } from "../../utils/standardNormalizer";

export type ComplianceDataSource = "EXTENDED" | "LEGACY_SHORT_LAYER" | "NONE";

/**
 * Phase 0 foundation service.
 * Extended-first strategy with safe legacy fallback.
 */
export function resolveStandardCode(inputCode: string | null | undefined): string {
  return getCanonicalStandardCode(inputCode);
}

export function resolveDataSource(params: { hasExtendedData: boolean; hasShortData: boolean }): ComplianceDataSource {
  if (params.hasExtendedData) return "EXTENDED";
  if (params.hasShortData) return "LEGACY_SHORT_LAYER";
  return "NONE";
}
